module.exports = __webpack_public_path__ + "static/gender_card_img5@2x-e3319668bff2cdaad1b95a24653d24f9.jpg";